(function() { /* Start dojo-webpack-plugin extensions */
		function mix(dest, src) { // eslint-disable-line no-unused-vars
			for(var n in src) dest[n] = src[n];
			return dest;
		}

		function toUrl(name, referenceModule) {
			return loaderScope.require.toUrl(name, referenceModule);
		}

		function toAbsMid(name, referenceModule) {
			return loaderScope.require.toAbsMid(name, referenceModule);
		}

		// dojo require function.
		function req(config, dependencies, callback) {
			return contextRequire(config, dependencies, callback, 0, req);
		};

		function createContextRequire(module) { // eslint-disable-line no-unused-vars
			if (!module) return req;
			var moduleId = module.absMid;
			if (!moduleId && req.absMidsById[module.id]) {
				moduleId = req.absMidsById[module.id];
			}
			if (!moduleId) return req;
			var result = function(a1, a2, a3) {
				return contextRequire(a1, a2, a3, moduleId, req);
			};
			for (var p in req) {
				if (req.hasOwnProperty(p)) {
					result[p] = req[p];
				}
			}
			result.toUrl = function(name) {
				return toUrl(name, moduleId ? {mid: moduleId} : null);
			};
			result.toAbsMid = function(name) {
				return toAbsMid(name, moduleId ? {mid: moduleId} : null);
			};

			if (req.undef) {
				result.undef = function(mid) {
					req.undef(mid, moduleId);
				};
			}
			return result;
		}

		function registerAbsMids(absMids) { // eslint-disable-line no-unused-vars
			for (var s in absMids) {
				req.absMids[s] = absMids[s];
				if (!req.absMidsById[absMids[s]]) {
					req.absMidsById[absMids[s]] = s;
				}
			}
		}

		function resolveTernaryHasExpression(expr) { // eslint-disable-line no-unused-vars
			// Expects an expression of the form supported by dojo/has.js loader, except that module identifiers are
			// integers corresponding to webpack module ids.  Returns a module reference if evaluation of the expression
			// using the currently defined features returns a module id, or else undefined.

			var has = findModule("dojo/has", null, false);
			var id = has.normalize(expr, function(arg){return arg;});
			return id && __webpack_require__(id) || undefined;
		}

		function findModule(mid, referenceModule, noInstall, asModuleObj) {
			mid = mid.split("!").map(function(segment) {
				var isRelative = segment.charAt(0) === '.';
				if(isRelative && !referenceModule){
					return segment;
				}
				return toAbsMid(segment, referenceModule ? {mid: referenceModule} : null);
			}).join("!");
			var result;
			if (mid in req.absMids && __webpack_require__.m[req.absMids[mid]]) {
				if (noInstall) {
					var module = __webpack_module_cache__[req.absMids[mid]];
					result = module && (asModuleObj ? module : module.exports);
				} else {
					result = __webpack_require__(req.absMids[mid]);
				}
			}
			if (!result) {
				throw new Error('Module not found: ' + mid);
			}
			return result;
		}

		function dojoModuleFromWebpackModule(webpackModule) { // eslint-disable-line no-unused-vars
			if (webpackModule.absMid) return webpackModule;  // Already converted
			var result = {i:webpackModule.id};
			var id = req.absMidsById[webpackModule.id];
			if (id) {
				result.id = result.absMid = id;
			}
			Object.defineProperty(result, "exports", {
				get: function() { return webpackModule.exports;},
				set: function(value) {webpackModule.exports = value;},
				enumerable: true,
				configurable: true
			});
			return result;
		}

		function contextRequire(a1, a2, a3, referenceModule, req) { // eslint-disable-line no-shadow
			var type = ({}.toString).call(a1);
			if (type === '[object String]') {
				// a3 is passed by require calls injected into dependency arrays for dependencies specified
				// as identifiers (vs. string literals).
				var noInstall = !(a3 === false);
				var m = findModule(a1, referenceModule, noInstall);
				if (typeof m === 'object' && m.__DOJO_WEBPACK_DEFINE_PROMISE__) {
					throw new Error('Module not found: ' + a1);
				}
				return m;
			} else if (type === '[object Object]') {
				throw new Error('Require config is not supported by WebPack');
			}
			if (type === '[object Array]') {
				var modules = [], callback = a2, errors = [];
				a1.forEach(function (mid) {
					try {
						modules.push(findModule(mid, referenceModule));
					} catch (e) {
						errors.push({mid: mid, error: e});
					}
				});
				if (errors.length === 0) {
					if (callback) {
						if (true && isDefinePromise(modules)) { // eslint-disable-line no-undef
							Promise.all(wrapPromises(modules)).then(function(deps) { // eslint-disable-line no-undef
								callback.apply(this, unwrapPromises(deps)); // eslint-disable-line no-undef
							}.bind(this)).catch(function(err){console.error(err);});
						} else {
							callback.apply(this, modules);
						}
					}
				} else {
					var error = new Error("findModules");
					error.src = "dojo-webpack-plugin";
					error.info = errors;
					req.signal("error", error);
				}
				return req;
			} else {
				throw new Error('Unsupported require call');
			}
		}
		req.toUrl = toUrl;
		req.toAbsMid = toAbsMid;
		req.absMids = {};
		req.absMidsById = [];
		req.async = 1;
		function wrapPromises(deps) {
			var result = (Array.isArray(deps) ? deps : [deps]).map(function(m) {
				return (m && typeof m.then === 'function' && !m.__DOJO_WEBPACK_DEFINE_PROMISE__) ? {__DOJO_WEBPACK_PROMISE_VALUE__: m} : m;
			});
			return Array.isArray(deps) ? result : result[0];
		}

		function unwrapPromises(deps) {
			var result = (Array.isArray(deps) ? deps : [deps]).map(function(m) {
				return m && m.__DOJO_WEBPACK_PROMISE_VALUE__ || m;
			});
			return Array.isArray(deps) ? result : result[0];
		}

		function isDefinePromise(values) {
			return (Array.isArray(values) ? values : [values]).some(function(dep) {
				return typeof dep === 'object' && dep.__DOJO_WEBPACK_DEFINE_PROMISE__;
			});
		}

		function asyncDefineModule(defArray, defFactory, module, exports) { // eslint-disable-line no-unused-vars

			function setDefinePromise(promise) {
				promise.__DOJO_WEBPACK_DEFINE_PROMISE__ = true;
				return promise;
			}

			function defModule(deps) {
				module && (module.exports = exports);
				var result =  defFactory.apply(null, deps);
				if (typeof module === 'function') {
					// module is actually a callback function
					module(result);
				} else {
					if (result !== undefined) {
						module.exports = result;
					} else {
						result = module.exports;
					}
				}
				return result;
			}

			if (!isDefinePromise(defArray)) {
				return defModule(defArray);
			} else {
				return setDefinePromise(Promise.all(defArray).then(function(deps) {
					return wrapPromises(defModule(unwrapPromises(deps)));
				}));
			}
		}
	var globalObj = this||window;
	registerAbsMids({
		// "/local/buildagent/work/7bfdef0d49469377/config/prod/configLoader.js" = 25597
		// "./config" = 52752
		// "/local/buildagent/temp/buildTmp/tmp-11876803dgHelRE9Ns/dojo/dojo.js" = 95758
	});

	globalObj.require = req;
		(self["webpackChunkmatlab_drive_webapp"] = self["webpackChunkmatlab_drive_webapp"] || []).registerAbsMids = registerAbsMids;

	// expose the Dojo compatibility functions as a properties of __webpack_require__
	if (__webpack_require__.dj && __webpack_require__.dj.name !== 'dojo-webpack-plugin') throw new Error("__webpack_require__.dj name collision.")
	__webpack_require__.dj = {
		name: 'dojo-webpack-plugin',
		r: req,
		c: createContextRequire,
		m: dojoModuleFromWebpackModule,
		h: resolveTernaryHasExpression,
		d: asyncDefineModule,
		w: wrapPromises,
		u: unwrapPromises
	};
	var loaderScope = Object.create(globalObj, {
	   document:{value: globalObj.document},
	});
	Object.defineProperties(loaderScope, {
	   window:{value:loaderScope},
	   global:{value:loaderScope}
	});
	loaderScope.define = loaderScope.require = undefined
	globalObj.dojoConfig = globalObj.dojoConfig || {}
	var userConfig = mix(globalObj.dojoConfig, ({'baseUrl':'.','packages':[({'name':'dojo','location':'target/debug/2P/derived/ui/dojo','lib':'.'}),({'name':'dijit','location':'target/debug/2P/derived/ui/dijit','lib':'.'}),({'name':'dojox','location':'target/debug/2P/derived/ui/dojox','lib':'.'}),({'name':'mw-log','location':'target/debug/2P/derived/ui/mw-log','lib':'.'}),({'name':'mw-utils','location':'target/debug/2P/derived/ui/mw-utils','lib':'.'}),({'name':'mw-ddux','location':'target/debug/2P/derived/ui/mw-ddux','lib':'.'}),({'name':'mw-progress-indicator','location':'target/debug/2P/derived/ui/mw-progress-indicator','lib':'.'}),({'name':'mw-widget-api','location':'target/debug/2P/derived/ui/mw-widget-api','lib':'.'}),({'name':'lit-element','location':'target/debug/2P/derived/ui/lit-element','lib':'.'}),({'name':'lit-html','location':'target/debug/2P/derived/ui/lit-html','lib':'.'}),({'name':'mw-statemachine','location':'target/debug/2P/derived/ui/mw-statemachine','lib':'.'}),({'name':'mw-peermodel','location':'target/debug/2P/derived/ui/mw-peermodel','lib':'.'}),({'name':'mw-deferred-utils','location':'target/debug/2P/derived/ui/mw-deferred-utils','lib':'.'}),({'name':'mw-remote','location':'target/debug/2P/derived/ui/mw-remote','lib':'.'}),({'name':'mw-messageservice','location':'target/debug/2P/derived/ui/mw-messageservice','lib':'.'}),({'name':'mw-html-utils','location':'target/debug/2P/derived/ui/mw-html-utils','lib':'.'}),({'name':'mw-browser-utils','location':'target/debug/2P/derived/ui/mw-browser-utils','lib':'.'}),({'name':'mldo-embedded-client','location':'target/debug/2P/derived/ui/mldo-embedded-client','lib':'.'}),({'name':'mw-filebrowser','location':'target/debug/2P/derived/ui/mw-filebrowser','lib':'.'}),({'name':'mw-filename-utils','location':'target/debug/2P/derived/ui/mw-filename-utils','lib':'.'}),({'name':'mw-actiondataservice','location':'target/debug/2P/derived/ui/mw-actiondataservice','lib':'.'}),({'name':'mw-keybindings','location':'target/debug/2P/derived/ui/mw-keybindings','lib':'.'}),({'name':'dgrid','location':'target/debug/2P/derived/ui/dgrid','lib':'.'}),({'name':'mw-menu','location':'target/debug/2P/derived/ui/mw-menu','lib':'.'}),({'name':'put-selector','location':'target/debug/2P/derived/ui/put-selector','lib':'.'}),({'name':'mw-mixins','location':'target/debug/2P/derived/ui/mw-mixins','lib':'.'}),({'name':'mw-gesture','location':'target/debug/2P/derived/ui/mw-gesture','lib':'.'}),({'name':'xstyle','location':'target/debug/2P/derived/ui/xstyle','lib':'.'}),({'name':'mw-dnd','location':'target/debug/2P/derived/ui/mw-dnd','lib':'.'}),({'name':'mw-form','location':'target/debug/2P/derived/ui/mw-form','lib':'.'}),({'name':'mw-dom-utils','location':'target/debug/2P/derived/ui/mw-dom-utils','lib':'.'}),({'name':'mw-event-utils','location':'target/debug/2P/derived/ui/mw-event-utils','lib':'.'}),({'name':'mw-ui-themes','location':'target/debug/2P/derived/ui/mw-ui-themes','lib':'.'}),({'name':'mw-utils','location':'target/debug/2P/derived/ui/mw-utils','trees':[['.','.',/(\/\.)|(~$)|(test|txt|BusyOverlay)/]],'lib':'.'})],'deps':['bootstrap'],'async':false,'has':({'config-deferredInstrumentation':false}),'supportedLocales':['en-us','ja-jp','ko-kr','zh-cn']}));
	var defaultConfig = ({'hasCache':({'webpack':1,'host-browser':1,'dom':1,'dojo-loader':1,'dojo-has-api':1,'dojo-dom-ready-api':1,'dojo-sniff':1,'dojo-test-sniff':1,'config-deferredInstrumentation':1,'config-tlmSiblingOfDojo':1})});
	var dojoLoader = __webpack_require__(95758);
	dojoLoader.call(loaderScope, userConfig, defaultConfig, loaderScope, loaderScope);
	Object.keys(loaderScope.require.packs).forEach(function(key) {
		var pkg = loaderScope.require.packs[key];
		if ((/(^\/)|(\:)/.test(pkg.main)	// main path is absolute
		    || pkg.main.split('/').reduce(function(acc, pathComp) {
					if (acc < 0 || pathComp === '.') return acc;
					return (pathComp === '..' ? --acc : ++acc);
				}, 0) <= 0) // main path is outside package
				&& typeof pkg.realMain === 'undefined'	// hasn't already been adjusted
		) {
			pkg.realMain = pkg.main;
			pkg.main = '';
		}
	});
	function toAbsMid(name, referenceModule) {
		var absMid = loaderScope.require.originalToAbsMid(name, referenceModule);
		if (absMid.indexOf('/') === absMid.length-1) {
			var pkgName = absMid.substring(0, absMid.length-1);
			var pkg = loaderScope.require.packs[pkgName];
			if (pkg && pkg.realMain) {
				absMid = pkgName;
			}
		}
		return absMid;
	}
	function toUrl(name, referenceModule) {
		var url = loaderScope.require.originalToUrl(name, referenceModule);
		var pkg = loaderScope.require.packs[name];
		if (pkg && pkg.realMain) {
			var parts = url.split('?');
			if (/(^\/)|(\:)/.test(pkg.realMain)) {
				// absolute URL
				parts[0] = pkg.realMain;
			} else {
				// relative URL
				parts[0] = parts[0] + '/' + pkg.realMain;
			}
			url = parts.join('?');
		}
		return url;
	}
	loaderScope.require.originalToAbsMid = loaderScope.require.toAbsMid;
	loaderScope.require.originalToUrl = loaderScope.require.toUrl;
	loaderScope.require.toAbsMid = toAbsMid;
	loaderScope.require.toUrl = toUrl;
	['baseUrl','has','rawConfig','on','signal'].forEach(function(name) {req[name] = loaderScope.require[name]})
	var absMidsWaiting = globalObj["webpackChunkmatlab_drive_webapp"].absMidsWaiting;
	if (absMidsWaiting) {
	   absMidsWaiting.forEach(registerAbsMids);
	   delete globalObj["webpackChunkmatlab_drive_webapp"].absMidsWaiting;
	}
})(); /* End dojo-webpack-plugin extensions */